import { CoreIcon } from '../core-icon';
import couponFillSVG from '../../assets/icons/coupon-fill.svg';
import type { IconProps } from '../core-icon';

export const CouponFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={couponFillSVG} {...props} />;
};
